import { type Registry as Services, service } from '@ember/service';
import Model, { type HasMany, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { TransactionMappingHierarchySubCategory } from 'lumen/models';
import type { Category } from 'lumen/utils/constants/transaction-mapping/constants';
import { CATEGORY_TRANSLATIONS } from 'lumen/utils/constants/transaction-mapping/translation-constants';

export default class TransactionMappingHierarchyCategory extends Model {
  [Type] = 'transaction-mapping/hierarchy-category' as const;

  @hasMany('transaction-mapping/hierarchy-sub-category', {
    async: false,
    inverse: 'category',
  })
  declare subCategories: HasMany<TransactionMappingHierarchySubCategory>;

  @service declare intl: Services['intl'];

  // @ts-expect-error: 'id' is defined as an accessor in class 'Model', but is overridden here in
  declare id: Category;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get translatedCategory() {
    if (!CATEGORY_TRANSLATIONS[this.id]) {
      return this.id;
    }

    return this.intl.t(CATEGORY_TRANSLATIONS[this.id]);
  }
}
